import { createFileRoute } from '@tanstack/react-router'
import { ContactFeature } from '@/features/contact/ContactFeature'

export const Route = createFileRoute('/contact')({
  component: ContactPage,
})

function ContactPage() {
  return <ContactFeature />
}
